import { CompanyData } from './CompanyData'
import { ShortCuts } from './ShortCuts'
import * as Styles from './styles'

export const Home = () => {
    return (
        <Styles.Container>
            <CompanyData />
            <ShortCuts />
        </Styles.Container>
    )
}
